import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  setDisplayName,
  withProps,
} from 'recompose';

import {
  GoogleMap,
  withGoogleMap,
  Marker,
} from 'react-google-maps';

import withGoogleMapJS from 'utils/mapping/withGoogleMapJS';

const LatLonPropType = PropTypes.shape({
  lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  lon: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
});

function latLonToLatLng({ lat, lon: lng }) {
  return {
    lat: parseFloat(lat),
    lng: parseFloat(lng),
  };
}

export class ServiceRequestMap extends Component {
  static propTypes = {
    serviceProviders: PropTypes.arrayOf(
      PropTypes.shape({
        address: PropTypes.shape({
          location: LatLonPropType,
        }),
      }),
    ).isRequired,
    currentLocation: LatLonPropType.isRequired,
    googleMaps: PropTypes.shape().isRequired,
  };

  state = {
    center: null,
    markers: [],
  };

  componentWillReceiveProps({ serviceProviders, currentLocation, googleMaps }) {
    const center = latLonToLatLng(currentLocation);

    if (isNaN(center.lat) || isNaN(center.lng) || !serviceProviders.length) {
      this.setState({ center: null, markers: [] });
      return;
    }

    const centerMarker = { ...center, id: 0 };
    const markers = [
      ...serviceProviders.map(this.providerToLatLng),
      centerMarker,
    ];
    this.setState({ markers, center });
    const newBounds = new googleMaps.LatLngBounds();

    if (markers.length) {
      markers.forEach(({ lat, lng }) => {
        newBounds.extend(new googleMaps.LatLng(lat, lng));
      });
    }

    if (this.map) {
      this.map.fitBounds(newBounds);
    }
  }

  setMapRef = (map) => {
    this.map = map;
  };

  /**
   * Extracts the geolocation and ID from a ServiceProvider.
   */
  providerToLatLng = ({ address: { location: { lat, lon } }, id }) => ({
    lat: parseFloat(lat), lng: parseFloat(lon), id,
  });

  render() {
    const { googleMaps } = this.props;
    const { center, markers } = this.state;
    // if no location is detected show US map
    return (
      <GoogleMap
        zoom={center ? 12 : 4}
        center={center || { lat: 39.5, lng: -98.35 }}
        ref={this.setMapRef}
      >
        {
          markers.map(({ lat, lng, id }, index) => (
            <Marker
              key={id}
              position={{ lat, lng }}
              label={id ? `${index + 1}` : ''}
              labelAnchor={new googleMaps.Point(lat, lng)}
              icon={id ? {
                path: googleMaps.SymbolPath.CIRCLE,
                strokeColor: 'white',
                scale: 15,
                fillColor: 'red',
                fillOpacity: 0.7,
                strokeWeight: 0.5,
              } : null}
            />
          ))
        }
      </GoogleMap>
    );
  }
}

export default compose(
  setDisplayName('ServiceRequestMap'),
  withProps({
    // props for withGoogleMap:
    containerElement: <div style={{ height: '100%' }} />,
    mapElement: <div style={{ height: '100%' }} />,
  }),
  withGoogleMapJS,
  withGoogleMap,
)(ServiceRequestMap);



// WEBPACK FOOTER //
// ./components/ServiceRequestMap/index.js